import ModalScreen from 'components/modal/ModalScreen';
import React, { PropsWithChildren, useState } from 'react';


import { CloseButton } from 'components/iconbutton/IconButton';
import styles from './FootballFieldModal.module.scss';

export type ASWidthSize = 'LargeWidth' | 'MediumWidth' | 'SmallWidth';

type FootballFieldModalOwnProps = {
  className?: string;
  onClose?: () => void;
  show?: boolean;
  openFromBottom?: boolean;
  title?: string;
  overlayCanClose?: boolean;
  widthSize?: ASWidthSize;
};
type FootballFieldModalProps = PropsWithChildren<FootballFieldModalOwnProps>;
const FootballFieldModal: React.FC<FootballFieldModalProps> = ({
  className = '',
  onClose = () => undefined,
  openFromBottom = false,
  children,
  show,
  overlayCanClose = false,
  title,
  widthSize = 'SmallWidth',
}) => {
  const openFromCls = openFromBottom ? styles.OpenFromBottom : styles.OpenFromTop;
  const showModalCls = openFromBottom ? styles.ShowModalFromBottom : styles.ShowModalFromTop;

  const [isVisible, setIsVisible] = useState<boolean>(!!show);
  if (show && !isVisible) {
    setIsVisible(true);
  }

  const visibleCls = show ? showModalCls : '';

  const widthCls = styles[widthSize];
  const baseCls = `${styles.FootballFieldModalContainer} ${openFromCls} ${className} ${widthCls}`;

  const closeModal = () => onClose();



  const onTransitionOver = () => {
    if (!show) setIsVisible(false);
  };

  const renderBase = () => {
    return (
      <div className={`${baseCls} ${visibleCls}`} onTransitionEnd={onTransitionOver}>
        <CloseButton onClick={closeModal} defaultLowOpacity={false} />
        {title && <div className={styles.FootballFieldModalTitle}>{title}</div>}
        {children}
      </div>
    );
  };

  const onOverlayClick = () => {
    if (overlayCanClose) closeModal();
  };

  return isVisible ? <ModalScreen onOverlayClick={onOverlayClick}>{renderBase()}</ModalScreen> : null;
};

export default FootballFieldModal;
